// extracted by mini-css-extract-plugin
export default {"label":"checkbox_label__HUAEx","choiceCheckBox":"checkbox_choiceCheckBox__7+iTk"};